import styled from 'styled-components';

export const MembershipListElement = styled.div`
  width: 100%;
  font-family: ${Styles.fontFamily.body};
  text-decoration: none;
  color: ${p => p.theme.token('text-default')};
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LinkStatusTag = styled.div`
  display: flex;
  justify-content: center;
  margin-inline-end: 0.5rem;
  align-items: center;
  background: #d1fae5;
  color: #418652;
  width: fit-content;
  padding: 0.3rem;
  border-radius: 0.25rem;
`;

export const LinkStatusText = styled.span`
  font-size: 0.9rem;
  line-height: 1rem;
  font-weight: 400;
  padding: 0 0.3rem;
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 15rem;
  width: 100%;
`;
